import { enParameters } from 'enums/enParameters';
import * as queryString from 'query-string';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { TRACKER_DATA, IS_ECOMMERCE } from 'settings';
import { Cookies } from 'react-cookie';

export interface IParameters {
  [key: string]: any;
}

export class ParameterService {
  private parameters$: BehaviorSubject<IParameters>;

  constructor() {
    const cookie = new Cookies();

    const qsParameters = queryString.parse(window.location.search);

    const parameters: IParameters = Object.keys(enParameters).reduce((acc, p) => {
      acc[p] = qsParameters[p] || (window.localStorage && window.localStorage.getItem(p)) || null;
      return acc;
    }, {});

    const trackerData = TRACKER_DATA || {};

    parameters.utmSource = `${qsParameters.utm_source || ''}` || trackerData.utmSource || null;
    parameters.utmMedium = `${qsParameters.utm_medium || ''}` || trackerData.utmMedium || null;
    parameters.utmCampaign = `${qsParameters.utm_campaign || ''}` || trackerData.utmCampaign || null;
    parameters.utmContent = `${qsParameters.utm_content || ''}` || trackerData.utmContent || null;
    parameters.a = `${qsParameters.a || ''}` || `${trackerData.affiliateId || ''}` || null;
    parameters.he = `${qsParameters.he || ''}` || trackerData.he || cookie.get('he') || null;
    parameters.ec = qsParameters.ec || IS_ECOMMERCE || null ? '1' : null;
    parameters.email = parameters.email || cookie.get('email') || null;
    parameters.lastKey = cookie.get('lastKey') || null;

    if (parameters.u === '1' && cookie.get('lastPaymentMethod') === 'bankslip') {
      parameters.upsell = '1';
    }

    this.parameters$ = new BehaviorSubject(parameters);
  }

  public get(key: enParameters): Observable<string> {
    return this.getAll()
      .map(parameters => parameters[key] || null)
      .distinctUntilChanged();
  }

  public setParameter(key: enParameters, value: string): void {
    const parameters = this.parameters$.value;
    parameters[key] = value;
    this.parameters$.next(parameters);
  }

  public getSync(key: enParameters): string {
    const parameters = this.parameters$.value;
    return parameters[key] || null;
  }

  public getAll(): Observable<IParameters> {
    return this.parameters$.asObservable().map(parameters => {
      return Object.keys(parameters).reduce((acc, i) => {
        if (parameters[i] !== null) {
          acc[i] = parameters[i];
        }
        return acc;
      }, {});
    });
  }
}

// tslint:disable-next-line:variable-name
export const ParameterServiceFactory = () => new ParameterService();

export const parameterService = ParameterServiceFactory();
